// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3j1an","buttons":"RemoveExpirationActionButtons_buttons__2Eldr"};